import { transformRoute } from "helpers";
import { NotificationEntityType } from "services/api/notifications/types";
// Izravno iz `routes`, ne iz `navigation` barrela — on povlači i stranice, a s njima
// lottie i ostatak stabla, što ovaj čisti helper ne treba.
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation/routes";

/**
 * Ruta koju klik na obavijest otvara, ili `null` kad se do entiteta ne može doći.
 *
 * Registracija i osiguranje nose sam id vozila, pa idu ravno na njegov detalj. Aparat,
 * ponuda, ugovor i račun žive pod vozilom, pa im treba `parentEntityId` — bez njega se ruta
 * ne može složiti i obavijest ostaje bez klika. Prilagođena notifikacija nema entitet.
 */
export const getNotificationRoute = (
  entityType: number | null,
  entityId: string | null,
  parentEntityId: string | null
): string | null => {
  if (!entityId) return null;

  switch (entityType) {
    case NotificationEntityType.VehicleRegistration:
    case NotificationEntityType.VehicleInsurance:
      return transformRoute(FleetVehicleRoutes.FleetVehicleDetailPageRouter, { id: entityId });

    case NotificationEntityType.FireExtinguisher:
      // Aparat nema vlastiti ekran; otvara se vozilo na kojem stoji.
      return parentEntityId
        ? transformRoute(FleetVehicleRoutes.FleetVehicleDetailPageRouter, { id: parentEntityId })
        : null;

    case NotificationEntityType.Offer:
      return parentEntityId
        ? transformRoute(FleetVehicleRoutes.FleetVehicleOfferSearchPageRouter, { id: parentEntityId })
        : null;

    case NotificationEntityType.Contract:
      return parentEntityId
        ? transformRoute(FleetVehicleRoutes.FleetVehicleContractSearchPageRouter, { id: parentEntityId })
        : null;

    case NotificationEntityType.Invoice:
      return parentEntityId
        ? transformRoute(FleetVehicleRoutes.FleetVehicleInvoiceSearchPageRouter, { id: parentEntityId })
        : null;

    default:
      return null;
  }
};
